import { Component, OnInit } from '@angular/core';

interface ReporteTab {
  id: string;
  label: string;
  icono: string;
  activo: boolean;
}

@Component({
  selector: 'app-client-reports',
  templateUrl: './client-reports.component.html',
  styleUrls: ['./client-reports.component.scss']
})
export class ClientReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  tabs: ReporteTab[] = [
    { id: 'planes-sin-beneficiario', label: 'PLANS_WITHOUT_BENEFICIARIES', icono: '', activo: true },
    // { id: 'reporte-2', label: 'REPORTE_2', icono: '📊', activo: false },
    // { id: 'reporte-3', label: 'REPORTE_3', icono: '📈', activo: false }
  ];

  tabActiva: string = 'planes-sin-beneficiario';

  cambiarTab(tabId: string): void {
    this.tabs.forEach(tab => tab.activo = tab.id === tabId);
    this.tabActiva = tabId;
  }

  get tabActual(): ReporteTab {
    return this.tabs.find(tab => tab.id === this.tabActiva)!;
  }

}